import { MessageCircle, Instagram, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="overflow-hidden border-t border-gold/15 bg-ink pb-10 pt-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <p
          aria-hidden="true"
          className="text-outline-gold select-none text-center font-serif text-[11vw] font-semibold leading-[1.05] lg:text-[7.5rem]"
        >
          UN ESPACIO PROPIO
        </p>

        <div className="mt-16 grid grid-cols-1 gap-10 border-t border-gold/10 pt-12 md:grid-cols-3">
          <div>
            <p className="font-serif text-xl italic text-cream">
              Un Espacio <span className="text-gold">Propio</span>
            </p>
            <p className="mt-3 max-w-xs text-sm font-light leading-relaxed text-ash">
              Lectura crítica de las cuatro bestias de la literatura argentina. Cohorte 2026.
            </p>
          </div>

          <div>
            <p className="font-sans text-[10px] uppercase tracking-[0.25em] text-gold">Contacto</p>
            <div className="mt-5 flex flex-col gap-4">
              <a
                href="https://wa.me/5491165168266"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="flex items-center gap-3 text-sm font-light text-bone transition-colors hover:text-gold"
              >
                <MessageCircle size={16} className="text-crimson-light" /> +54 9 11 6516 8266
              </a>
              <a
                href="mailto:sol.criscione@gmail.com"
                data-testid="footer-email-link"
                className="flex items-center gap-3 text-sm font-light text-bone transition-colors hover:text-gold"
              >
                <Mail size={16} className="text-crimson-light" /> sol.criscione@gmail.com
              </a>
              <a
                href="https://instagram.com/un.espacio.propio"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                className="flex items-center gap-3 text-sm font-light text-bone transition-colors hover:text-gold"
              >
                <Instagram size={16} className="text-crimson-light" /> @un.espacio.propio
              </a>
            </div>
          </div>

          <div>
            <p className="font-sans text-[10px] uppercase tracking-[0.25em] text-gold">El programa</p>
            <div className="mt-5 flex flex-col gap-3">
              <a href="#programa" className="text-sm font-light text-bone transition-colors hover:text-gold">Sobre el programa</a>
              <a href="#cronograma" className="text-sm font-light text-bone transition-colors hover:text-gold">Cronograma</a>
              <a href="#autoras" className="text-sm font-light text-bone transition-colors hover:text-gold">Las cuatro</a>
              <a href="#postulacion" data-testid="footer-cta-postulacion" className="text-sm font-light text-bone transition-colors hover:text-gold">Postularme</a>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-gold/10 pt-8 sm:flex-row">
          <p className="font-sans text-[10px] uppercase tracking-[0.25em] text-ash">
            © 2026 Un Espacio Propio · Buenos Aires
          </p>
          <p className="font-serif text-sm italic text-ash">Hecho con tinta y fuego lento.</p>
        </div>
      </div>
    </footer>
  );
}
